import { SERVER_DAY_FORMAT } from 'lib/config';
import { moment } from 'lib/momentWithRange';
import { DateType } from 'type';

export const dayValidator = (day: DateType | string | undefined) =>
  moment(day, SERVER_DAY_FORMAT).isValid();
